import image from "../assets/map/route-2.png";
import music from "../assets/music/maps/route-1.mp3";
import getEncounterData from "./get-location-data";
import { MapId, MapType } from "./map-types";

const route2: MapType = {
  name: "Route 2",
  image,
  music,
  height: 72,
  width: 20,
  start: {
    x: 8,
    y: 70,
  },
  walls: {
    0: [7, 10],
    1: [0, 1, 2, 3, 4, 5, 6, 7, 10, 11, 15, 16, 17, 18, 19],
    2: [10],
    3: [10],
    4: [10],
    5: [10],
    6: [10, 11, 12, 13, 14, 15, 16, 17],
    7: [10, 17],
    8: [10, 17],
    9: [10, 11, 12, 13, 14, 15, 16, 17],
    10: [0, 1, 2, 4, 5, 6, 7, 8, 9],
    11: [2, 4, 11],
    12: [2, 3, 4, 5],
    13: [2, 3, 4, 5],
    14: [2, 3, 4, 5],
    15: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
    16: [8, 13],
    17: [8, 13],
    18: [8, 13, 14, 15, 16, 17],
    19: [8, 13, 14, 15, 16, 17],
    20: [8, 13],
    21: [8, 13],
    22: [0, 1, 2, 3, 4, 5, 6, 7, 14, 15, 16, 17, 18, 19],
    23: [14],
    24: [13],
    25: [13],
    26: [13],
    27: [13],
    28: [13],
    29: [13],
    30: [13],
    31: [13],
    32: [13],
    33: [13],
    34: [13],
    35: [13, 14, 15, 18, 19],
    36: [13, 16, 17],
    37: [3, 13],
    38: [0, 1, 2, 4, 5, 6, 7, 8, 9, 13],
    39: [2, 4, 10, 13, 14, 15, 16, 17, 18, 19],
    40: [2, 3, 4, 5, 10, 13],
    41: [2, 3, 4, 5, 10, 13],
    42: [2, 3, 4, 5, 10, 13],
    43: [0, 1, 2, 4, 5, 6, 7, 8, 9, 10, 13],
    44: [11],
    45: [11],
    46: [11],
    47: [11],
    48: [11],
    49: [11],
    50: [11],
    51: [11],
    52: [12],
    53: [6, 7, 8, 9, 10, 11, 12, 13],
    54: [5, 6, 7, 8, 9, 10, 11, 12],
    55: [5, 6, 7, 8, 9, 10, 11, 12],
    56: [6, 7, 8, 9, 10, 11, 12],
    57: [12],
    58: [12],
    59: [12],
    60: [0, 1, 12],
    61: [1, 12],
    62: [1, 12],
    63: [1, 12],
    64: [1, 12],
    65: [1, 5, 12],
    66: [1, 12],
    67: [1, 12],
    68: [1, 12],
    69: [1, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
    70: [2, 3, 4, 5, 6, 10],
    71: [6, 10],
  },
  fences: {
    19: [0, 1, 2, 3, 4, 5, 6, 7],
    27: [14, 15, 16, 18, 19],
    31: [14, 15, 16, 18, 19],
    43: [14, 16, 17, 18, 19],
    47: [0, 1, 2, 3, 4, 5, 6, 7],
    49: [12, 13, 14, 16, 17, 18, 19],
    61: [2, 3, 4, 5, 6, 8, 9, 10, 11],
  },
  grass: {
    2: [0, 1, 2, 3, 4, 5, 6, 7],
    3: [0, 1, 2, 3, 4, 5, 6, 7],
    4: [0, 1, 2, 3, 4, 5, 6, 7],
    5: [0, 1, 2, 3, 4, 5, 6, 7],
    6: [0, 1, 2, 3, 4, 5, 6, 7],
    7: [0, 1, 2, 3, 4, 5, 6, 7],
    20: [0, 1, 4, 5, 6, 7],
    21: [0, 1, 4, 5, 6, 7],
    48: [4, 5, 6, 7, 8, 9],
    49: [4, 5, 6, 7, 8, 9],
    50: [4, 5, 6, 7, 8, 9],
    51: [4, 5, 6, 7, 8, 9],
  },
  text: {
    11: {
      11: [
        "Lorem ipsum dolor sit amet, consectetur",
        "adipiscing elit, sed do eiusmod tempor",
        "incididunt ut labore et dolore magna aliqua.",
      ],
    },
    65: {
      5: ["Route 2 VIRIDIAN CITY to PEWTER CITY"],
    },
  },
  maps: {
    43: {
      3: MapId.Route2Gate,
    },
  },
  exits: {
    71: [7, 8, 9],
  },
  exitReturnPos: {
    x: 18,
    y: 1,
  },
  encounters: getEncounterData("kanto-route-2-south-towards-viridian-city"),
  exitReturnMap: MapId.ViridianCity,
};

export default route2;
